import { formatNumber } from '@/services/translate';

const minimumValueForStandardFormat = 0.001;
const maximumValueForStandardFormat = 1000000.0;

const dictionarySuperscript = {
  0: '\u2070',
  1: '\u00b9',
  2: '\u00b2',
  3: '\u00b3',
  4: '\u2074',
  5: '\u2075',
  6: '\u2076',
  7: '\u2077',
  8: '\u2078',
  9: '\u2079',
  '-': '\u207b',
  '+': '',
};

export function checkNumberIsValidForScientificNotation(number) {
  const validNumber = typeof number !== 'number' ? parseFloat(number) : number;
  const absoluteNumber = Math.abs(validNumber);
  return (absoluteNumber < minimumValueForStandardFormat
    || absoluteNumber >= maximumValueForStandardFormat)
    && absoluteNumber !== 0;
}

export default function exponentialFilter(value, decimalDigits) {
  if (typeof value !== 'number') return value;
  const exponential = value.toExponential();
  const splitExponential = exponential.split('e');
  const coefficient = splitExponential[0];
  const exponent = splitExponential[1];

  const coefficientFormatted = formatNumber(coefficient, {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimalDigits,
  });

  const exponentFormatted = [...exponent]
    .map(char => char.replace(char, dictionarySuperscript[char]))
    .join('');

  return `${coefficientFormatted} x 10${exponentFormatted}`;
}
